/**
 *   This is a service for a specific store module which uses the api.ts Axios instance as a base.
 *   We separate our files for easy managment and readibility.
 *   We export this as a service to be used in other areas of the application.
 */

import Api from '@/services/api';
import AppService from '@/services/app';
import Store from '@/store/index';

export default {

  resetTypes() {
    // reset store to empty
    Store.dispatch('users/setUserTypes', {
      userTypes: [],
    });
  },

  async listTypes(refreshFromAPI: boolean) {
    // check if we need to force an API refresh or have already fetched this data and it is in the Store
    if (refreshFromAPI || Store.getters['users/userTypes'].length < 1) {
      try {
        const response = await Api(false).get('/user/list_types');
        
        if (response && response.data) {
          if (response.data.result && response.data.result === 'false') {
            this.resetTypes();
            return response.data.message;
          } else {
            Store.dispatch('users/setUserTypes', {
              userTypes: response.data,
            });
            return '';
          }
        } else {
          // response is undefined or has no data field - SHOULD NEVER HAPPEN!
          throw new Error('response: ' + JSON.stringify(response));
        }

      } catch (error) {
        this.resetTypes();
        if (error.response) {
          return error.response.statusText;
        } else {
          AppService.logSupportDebug('user.ts - listTypes - 46 - ' + error);
          return Store.getters['app/messages'].couldNotConnect;
        }
      } 
    } else {
      // this data is ready to access in the Store
      return '';
    }
  },

  resetStore() {
    // reset store to empty
    Store.dispatch('users/setUsers', {
      users: [],
    });
  },

  async listAll(refreshFromAPI: boolean) {
    // check if we need to force an API refresh or have already fetched this data and it is in the Store
    if (refreshFromAPI || Store.getters['users/users'].length < 1) {
      try {
        const response = await Api(true).get('/user/list_all');
        
        if (response && response.data) {
          if (response.data.result && response.data.result === 'false') {
            this.resetStore();
            return response.data.message;
          } else {
            Store.dispatch('users/setUsers', {
              users: response.data,
            });
            return '';
          }
        } else {
          // response is undefined or has no data field - SHOULD NEVER HAPPEN!
          throw new Error('response: ' + JSON.stringify(response));
        }

      } catch (error) {
        this.resetStore();
        if (error.response) {
          return error.response.statusText;
        } else {
          AppService.logSupportDebug('user.ts - listAll - 89 - ' + error);
          return Store.getters['app/messages'].couldNotConnect;
        }
      } 
    } else {
      // this data is ready to access in the Store
      return '';
    }
  },

  create(params: { 
    userTypeId: number,
    clearanceLevel: number,
    username: string, 
    password: string, 
    firstName: string, 
    lastName: string, 
    email: string,
  }) {
    return Api(true).post('/user/create', params);
  },

  update(params: { 
    id: number,
    userTypeId: number,
    clearanceLevel: number,
    firstName: string, 
    lastName: string, 
    email: string,
  }) {
    return Api(true).post('/user/update', params);
  },

  delete(params: { id: number }) {
    return Api(true).post('/user/delete', params);
  },

  resetPassword(params: { 
    id: number, 
    password: string,
  }) {
    return Api(true).post('/user/reset_password', params);
  },

};
